import React, { useState, useEffect } from 'react';
import { Editor, Toolbar } from '@wangeditor/editor-for-react';
import '@wangeditor/editor/dist/css/style.css';
import styled from "styled-components";
import {useUploadImage} from "../../../utils/hooks/useUploadImage";
import {LabelPosition} from "../../../components/constants";
import _ from 'lodash';

const EditorWrapper = styled.div<{
  labelWidth: number;
  labelPosition: string;
  isRequired: boolean;
}>`
  display: ${({labelPosition}) => labelPosition===LabelPosition.Top?'block':'flex'};
  height: 100%;
  min-height: 300px;
  .label-left{
    width: ${({labelWidth}) => labelWidth*10}px;
    min-height: 30px;
    line-height: 30px;
    .label-left-required{
      display: ${({isRequired}) => isRequired?'inline-block':'none'};
      margin-right: 4px;
      color: #ff4d4f;
      font-size: 14px;
      font-family: SimSun,sans-serif;
    }
  }
  .w-e-full-screen-container{
    left: ${({labelWidth}) => labelWidth*10}px!important;
    width: calc(100% - ${({labelWidth}) => labelWidth*10}px)!important;
  }
  .w-e-text-container{
    min-height: 300px;
    h1{ font-size: 2em; }
    h2{ font-size: 1.5em; }
    h3{ font-size: 1.17em; }
    h5{ font-size: 0.83em; }
    h6{ font-size: 0.67em; }
  }
  .w-e-scroll{
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
  }
`;

function RichTextEditor(props:any){
  const {labelText, labelWidth, labelPosition, defaultValue, value, isRequired, onValueChange, isReadonly} = props;
  const [editor, setEditor] = useState<any>(null); // 存储 editor 实例
  const {uploadImageCode} = useUploadImage();

  const editorChange = (str:string) =>{
    onValueChange&&onValueChange(str);
  }
  // 模拟异步设置 html
  useEffect(() => {
    if((value===''||value===defaultValue)&&defaultValue){
      editorChange(`<p><strong>${defaultValue}</strong></p>`);
    }
  }, []);

  const toolbarConfig = {
    excludeKeys: ['fullScreen']
  }; // 工具栏配置
  const editorConfig = {
    placeholder: '请输入内容...',
    MENU_CONF: {
      uploadImage: {
        allowedFileTypes: ['image/jpg', 'image/jpeg', 'image/png'],
        // 自定义上传
        async customUpload(file: File, insertFn: any) {
          uploadImageCode(file, (code:string, url:string)=>{
            insertFn(url, '', '#');
          });
        },
      },
      uploadVideo: {
        // 自定义上传
        async customUpload(file: File, insertFn: any) {
          uploadImageCode(file, (code:string, url:string)=>{
            insertFn(url, '');
          });
        }
      }
    },
    onChange: (newHtml:any) => {
      editorChange(newHtml.getHtml());
    },
    readOnly: isReadonly,
  }; // 编辑器配置

  // 组件销毁时，及时销毁 editor 防止内存泄漏
  useEffect(() => {
    if (editor != null && editor.getEditableElement) {
      const editableElement = editor.getEditableElement();
      if (editableElement) {
        editableElement.setAttribute('contenteditable', !isReadonly);
      }
    }

    return () => {
      if (editor == null) return;
      editor.destroy();
      setEditor(null);
    };
  }, [editor, isReadonly]);
  let richStyle:any = {
    zIndex: 100,
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  };
  if(!isReadonly){
    richStyle.border = '1px solid #ccc';
  }

  return (
    <EditorWrapper labelWidth={_.isEmpty(_.trim(labelText))?0:labelWidth} labelPosition={labelPosition} isRequired={isRequired}>
      <div className='label-left'>
        <span className="label-left-required">*</span>{labelText}
      </div>
      <div style={richStyle}>
        {isReadonly&&
          <div dangerouslySetInnerHTML={{ __html: value }} />
        }

        {!isReadonly && <>
            <Toolbar
              editor={editor}
              defaultConfig={toolbarConfig}
              mode="default"
              style={{ borderBottom: '1px solid #ccc' }}
            />

            <Editor
             defaultConfig={editorConfig}
              value={value}
              onCreated={(editor:any) => {
                setEditor(editor);
              }}
              mode="default"
              style={{ flex: 1 }}
            />
          </>
        }

      </div>
    </EditorWrapper>
  );
}

export default RichTextEditor;
